import styled from 'styled-components/macro'


export const Container = styled.section`
  padding: 56px 0 32px 0;
`
export const Card = styled.section`
  padding: 16px;
  border: 1px solid #ececec;
  border-radius: 5px;
  margin: 8px 16px 0px 16px;
`
export const CardHeader = styled.section`
display: flex;
align-items: center;
`
export const Icon = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
`
export const HeaderTitle = styled.h3`
  font-size: 16px;
  margin: 0px 12px 0px 12px;
`
export const Ul = styled.ul`
  padding-right: 26px;
  margin: 16px 0 0 0;
  color: #9b9b9b;
`
export const Label = styled.p`
  padding-right: 16px;
  color: #4d4d4d;  
  margin-bottom:8px
`
